/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_P_Cli_DescInputs */

const en_cad_agents_p_cli_desc = /** @type {(inputs: Cad_Agents_P_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script drawings, inspect files and batch-convert DWG/DXF to SVG or PNG in CI pipelines.`)
};

/**
* | output |
* | --- |
* | "Script drawings, inspect files and batch-convert DWG/DXF to SVG or PNG in CI pipelines." |
*
* @param {Cad_Agents_P_Cli_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_p_cli_desc = /** @type {((inputs?: Cad_Agents_P_Cli_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_P_Cli_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_p_cli_desc(inputs)
});
export { cad_agents_p_cli_desc as "cad.agents.p_cli_desc" }